import { RootState } from '@src/store/store'
import { UserStateType } from '@src/store/ducks/user/reducer'

export const selectUser = (state: RootState): UserStateType => state.user
export const selectUserPoints = (state: RootState) => selectUser(state).points
export const selectProfile = (state: RootState) => selectUser(state).profile
export const selectSuccessChangeField = (state: RootState) => selectUser(state).successChangeField
export const selectSuccessChangePhone = (state: RootState) => selectUser(state).successChangePhone
export const selectUserPurchases = (state: RootState) => selectUser(state).purchases
export const selectUserChips = (state: RootState) => selectUser(state).electronicChips
export const selectUserProductGroup = (state: RootState) => selectUser(state).productGroup
export const selectUserChangePassword = (state: RootState) => selectUser(state).successChangePassword
export const selectIsStatusDeleteUser = (state: RootState): boolean => selectUser(state).isDeleteProfileStatus
